import { useWindowSize } from 'react-use'
import { isMobile } from '../../utils/isMobile'

export function useIsMobile(): boolean {
  const { width } = useWindowSize()
  return isMobile(width)
}
